import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import 'animate.css';
import CaseDetails from './CaseDetail';
import { useLocation } from 'react-router-dom';
import { Link } from '@mui/material';
import Grid from '@mui/material/Grid';
import PageMeta from '../modules/components/PageMeta';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

function pushCards(ary, maxNum, strFolder1, strFolder2) {
  for (var i = 1; i <= maxNum; i++) {
    ary.push({
      title: `${strFolder2}`,
      message: '',
      img_path: `/images/case/${strFolder1}/${strFolder2}/${i}.jpg`,
    });
  }
}

function Index() {
  const query = useQuery();
  const title = query.get('title') || '①和室解体工事';
  const page = query.get('page') || 5;
  const name = title.substring(1);
  var cards = [];
  pushCards(cards, page, 'reform', title);

  return (
    <React.Fragment>
      <PageMeta
        title={`リフォーム - ${name}｜施工事例`}
        description={`飯田建築のリフォーム施工事例「${name}」。埼玉県入間市の工務店・飯田建築有限会社の施工写真をご覧いただけます。`}
        path={`/case/reform/detail?title=${title}`}
        image={`/images/case/reform/${title}/1.jpg`}
      />
      <NavBar />
      <CaseDetails
        title={'リフォーム - ' + title.substring(1, title.length)}
        cards={cards}
        animation={'animate__animated animate__fadeIn'}
      />
      <Grid container alignItems="center" justifyContent="center" sx={{ pt: 4, pb: 4 }}>
        <Link variant="h5" href="/case/reform" color="inherit">
          {'<'} 戻る
        </Link>
      </Grid>
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
